__turbopack_context__.v({
  "wrapper": "certifying-letters-module-scss-module__pmTt2G__wrapper",
  "wrapper__label": "certifying-letters-module-scss-module__pmTt2G__wrapper__label",
  "wrapper__link-skeleton": "certifying-letters-module-scss-module__pmTt2G__wrapper__link-skeleton",
  "wrapper__links": "certifying-letters-module-scss-module__pmTt2G__wrapper__links",
});
